import { useRef, useState } from "react";
import PlayIcon from "../../Assets/Images/home/play-icon.png";
import thumb from "../../Assets/Images/home/howto.png";
import "./howtoscheduleblock.css";
import { BsFillPlayCircleFill, BsFillPauseCircleFill } from "react-icons/bs";
// if you have styling

const HowToScheduleBlock = ({ image, name }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className={`howtoschedule-ss-block-ui brightness`}>
      {/* Image */}
      <div className="ssb-img">
        {/* <img src={image} alt={name} /> */}
        <div className="video-container">
          <video
            ref={videoRef}
            src="https://shootin-frontend.s3.us-east-1.amazonaws.com/How+to+Book+a+Session.mp4"
            poster={thumb}
            className="w-full"
            controls
            playsInline
            onEnded={handleVideoEnd}
            style={{ width: "100%" }}
          />
          {/* <div className="video-controls">
              {!isPlaying && (
                <button onClick={togglePlay} className="video-play-btn">
                  <img src={PlayIcon} alt="play" width={80} />
                </button>
              )}
            </div> */}
        </div>
      </div>
    </div>
  );
};

export default HowToScheduleBlock;
